"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _stylesModule = _interopRequireDefault(require("./styles.module.css"));
var _finishingFlag = require("../assets/finishing-flag.svg");
var _greenTick = require("../assets/green-tick.svg");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const WonOverlay = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: _stylesModule.default.overlay,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _stylesModule.default.tutorialBody,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _stylesModule.default.singleColumnContainer,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_finishingFlag.ReactComponent, {
          className: _stylesModule.default.tickIconFullScreen
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_greenTick.ReactComponent, {
          className: _stylesModule.default.tickIconFullScreen
        })]
      })
    })
  });
};
var _default = exports.default = WonOverlay;